/** Zod の issue を `{ 'groups.sen.priority1': ['…'] }` の形にまとめる(サーバーのエラー応答と画面の入力欄の名前が一致する)。 */
export const zodIssuesToFieldErrors = (
  issues: readonly { path: readonly PropertyKey[]; message: string }[],
): Record<string, string[]> => {
  const out: Record<string, string[]> = {};
  issues.forEach((issue) => {
    const key = issue.path.map(String).join('.') || '_';
    out[key] = [...(out[key] ?? []), issue.message];
  });
  return out;
};

/** サーバーが `ideas[0].text` の形で返す添字を、画面の入力欄の名前 `ideas.0.text`(契約のドット区切り)にそろえる。 */
export const normalizeFieldErrorKeys = (
  errors: Readonly<Record<string, readonly string[]>> | null | undefined,
): Record<string, string[]> | null => {
  if (errors === null || errors === undefined) return null;
  const out: Record<string, string[]> = {};
  Object.entries(errors).forEach(([key, messages]) => {
    const name = key.replace(/\[(\d+)\]/g, '.$1').replace(/^\./, '');
    out[name] = [...(out[name] ?? []), ...messages];
  });
  return out;
};
